module.exports = __webpack_public_path__ + "img/dash_picture.53251fe3.png";